import { Divider, Icon, Row, Tooltip } from 'antd'
import { TooltipProps } from 'antd/lib/tooltip'
import { TypographyProps } from 'antd/lib/typography'
import React from 'react'
import Popover, { PopoverProps } from 'antd/lib/popover'
import { IconProps } from 'antd/lib/icon'
import { DividerProps } from 'antd/lib/divider'
import { useSelector } from '../../../redux/store'
import { IState } from '../../../redux/reducer'
import { getPrimaryColor } from '../../../common/helper'

export type TFormItemLabel = {
  text?: string | React.ReactNode
  children?: React.ReactNode
  icon?: React.ReactNode
  divide?: boolean
  tooltip?: string
  popover?: string | React.ReactNode
  requiredMark?: boolean
  style?: React.CSSProperties

  iconProps?: IconProps
  popoverProps?: PopoverProps
  typographyProps?: TypographyProps
  tooltipProps?: TooltipProps
  dividerProps?: DividerProps
}

export const FormItemLabel = (props: TFormItemLabel) => {
  const uiSetting = useSelector((state: IState) => state.uiSetting)
  const primaryColor = getPrimaryColor(uiSetting)

  return (
    <Row type='flex' align='middle' style={{ maxWidth: "fit-content", ...props.style }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <span className='txt-black-color-95' style={props.style}>{props.text}</span>
        {props.requiredMark && <span style={{ color: primaryColor }}>*</span>}
        {props.tooltip || props.tooltipProps ? (
          <Tooltip placement='top' title={props.tooltip} {...props.tooltipProps} style={{ maxWidth: "fit-content" }}>
            {props.icon || <Icon type='question-circle' {...props.iconProps} className='txt-black-color-35' />}
          </Tooltip>
        ) : props.popover || props.popoverProps ? (
          <Popover content={props.popover} {...props.popoverProps} style={{ maxWidth: "fit-content" }}>
            {props.icon || <Icon type='question-circle' {...props.iconProps} className='txt-black-color-35' />}
          </Popover>
        ) : null}
      </div>
      {props.divide && <Divider {...props.dividerProps} type='vertical' />}
      {props.children}
    </Row>
  )
}

